module.exports = "<ul id=\"al-sidebar-list\" class=\"al-sidebar-list\" baSlimScroll [baSlimScrollOptions]=\"{height: menuHeight}\"\n    (mouseleave)=\"hoverElemTop=outOfArea\">\n  <ba-menu-item\n    [menuItem]=\"item\"\n    (itemHover)=\"hoverItem($event)\"\n    (toggleSubMenu)=\"toggleSubMenu($event)\"\n    (menupdated)=\"onMenuUpdated($event)\"\n    *ngFor=\"let item of menuItems\"></ba-menu-item>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baMenu/baMenu.html
// module id = ./src/app/theme/components/baMenu/baMenu.html
// module chunks = main